import React from 'react';
import './App.css';
import Animation from './components/Animation';

function App() {
  return (
    <div className="App">
      <Animation width="600" height="600" ></Animation>
    </div>
  );
}

export default App;
